import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 14\" id=\"logout\"><g stroke=\"#DE2230\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M5 13H2.333A1.333 1.333 0 0 1 1 11.667V2.333C1 1.597 1.597 1 2.333 1H5M9.667 10.333L13 7 9.667 3.667M13 7H5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol